import React from 'react';
import './list-of-links.scss';
export default function ListOfLinks({ children }) {
    return (React.createElement("ul", { className: "list-of-links" }, React.Children.toArray(children).map((c, i) => (React.createElement("li", { key: i }, c)))));
}
